"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 判断是否数字
 * @return {Boolean} 是否数字
 */
var is_type_1 = require("./is-type");
var isNumber = function (value) {
    return is_type_1.default(value, 'Number');
};
exports.default = isNumber;
//# sourceMappingURL=is-number.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-number.js
// module id = 132
// module chunks = 37